import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { Proxy, withArtifex } from "core";
import Formatter from "core/Formatter";
import { DeleteIcon, EditIcon } from "core/Icons";
import PropTypes from "prop-types";
import React from "react";
import { GenericAlert, GenericExpansionPanel, GenericGrid, GenericTextInput } from "views/Components/Generic";
import GridButton from "views/Components/GridButton";
import LoadingComponent from "views/Components/LoadingComponent";
import { ActionCodes, MenuCodes, GridColumnType } from "views/Constants/Constant";
class KYCStatus extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			kycModel: {},
			alert: null,
			isLoading: false,
			CustomDisabled: null,
			vModel: {}
		};
		this.ParameterMaxLength100 = { maxLength: 100 };
		this.CloumnsData = [
			{
				Header: "State",
				accessor: "Description"
			},
			{
				Header: "Last Status Update",
				accessor: "InsertDateTime",
				type: GridColumnType.Date
			}
		];
	}
	componentDidMount() {
		if (this.props.setAppLeftTitle)
			this.props.setAppLeftTitle("KYC Status");
		const global = { ...this.props.paramGlobalModel };
		
		var model = { Id: 0, UniqueClientId: global.Id };
		this.setState({ kycModel: model });
	}
	ShowMessageNode = (type, title, message) => {
		this.setState({
			alert: <GenericAlert Title={title} MessageNode={message} Type={type} OnConfirm={() => this.hideAlert()} />
		});
		this.setState({ isLoading: false });
	}
	handleChange = (name, newValue) => {
		this.setState(function (state, props) {
			var model = state.kycModel || {};
			model[name] = newValue;
			return { kycModel: model };
		});
	}
	SelectedRowChange = (e, index) => {
		const model = this.props.paramBankCustomerKYCStatus[index];
		this.setState({ kycModel: model });
	}
	ClearData = () => {
		const global = { ...this.props.paramGlobalModel };
		var model = { Id: 0, UniqueClientId: global.Id };
		this.setState({ kycModel: model, vModel: {} });
	}
	hideAlert = () => {
		this.setState({
			alert: null,
			isLoading: false
		});
	}
	render() {
		const { Disabled: DisabledProp, paramBankCustomerKYCStatus } = this.props;
		const { kycModel, vModel } = this.state;
		const Disabled = DisabledProp || this.state.CustomDisabled;
		return (
			<GridContainer spacing={16}>
				{this.state.alert}
				<GridContainer justify="flex-end">
					<GridItem style={{ float: "right" }}>
						<Button disabled={Disabled} size="sm" color="black" onClick={() => {
							if (this.props.isSalesAgentPersonel)
								this.props.handleChangeParentTab(null, 3);
							else if (this.props.MenuCode == MenuCodes.CallCenterClientMonitor)
								this.props.handleChangeParentTab(null, 4);
							else
								this.props.handleChangeParentTab(null, 5);
						}} > Back </Button>
					</GridItem>
				</GridContainer>
				<GridItem xs={12}>
					{this.state.alert}
					<LoadingComponent Show={this.state.isLoading} />
					<Card className="no-radius">
						<CardBody>
							<GridItem xs={12}>
								<GridItem>
									<GenericGrid
										Data={paramBankCustomerKYCStatus}
										PageSize={5}
										HideButton={true}
										Columns={this.CloumnsData}
									/>
								</GridItem>
							</GridItem>
						</CardBody>
					</Card>
				</GridItem>
			</GridContainer>
		);
	}
}
KYCStatus.propTypes = {
	classes: PropTypes.object,
	kycModel: PropTypes.object,
	paramGlobalModel: PropTypes.object,
	paramBankCustomerKYCStatus: PropTypes.array,
	handleChangeParentTab: PropTypes.func
};
export default withArtifex(KYCStatus, {});